module.exports = __webpack_public_path__ + "static/media/icon-team-survey-progress-not-started.c27dce3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-team-survey-progress-not-started.svg
// module id = 1904
// module chunks = 0